import React, {useEffect, useState} from 'react';
import {getLanguage, t} from 'react-switch-lang';
import Modal from 'reactstrap/lib/Modal';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import * as yup from 'yup';
import './modal.scss';
import Toast from '../../../../components/toast/Toast';
import SelectInfinite from "../../../../components/FormFields/SelectInfinite";
import InputText from "../../../../components/FormFields/InputText";
import InputDate from "../../../../components/FormFields/inputDate/InputDate";
import {addCodebook, updateCodebook} from "../../../../services/IncurredEvent/incurredEventApi";
import {nanoid} from "nanoid";

function LossModal({id, open, isOpen,setLossData,lossData, isEdit,riskId}) {
    const schema = yup.object().shape({
        lossReason: yup.object().nullable().required(t('message.fieldRequired')),
        netLoss: yup
            .string()
            .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                if (!value) return false;
                const normalizedValue = value.replace(',', '.');
                return !isNaN(normalizedValue) && parseFloat(normalizedValue) > 0.1;
            }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                if (!value) return false;
                const normalizedValue = value.replace(',', '.');
                return /^-?\d+(\.\d{1,2})?$/.test(normalizedValue);
            })
            .required(t('message.fieldRequired')),
        lossDate: yup
            .string()
            .nullable()
            .required(t('message.fieldRequired')),
    });
    const [loading,setLoading] = useState(false);
    const [localEditData,setLocalEditData] = useState([]);
    const [isCalendarOpen,setIsCalendarOpen] = useState(false);

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const {handleSubmit, watch} = methods;
    const toggleShowModal = (e) => {
        e && e.preventDefault();
        isOpen(!open);
    };

    useEffect(() => {
        setLocalEditData(lossData.find((loss) => loss.id === id));
    },[id])

    const watchComment = watch('comment');
    const submitForm = async (data) => {
        setLoading(true);
        if(isEdit) {
            if(riskId) {
                updateCodebook({...data,id:localEditData?.id,lossDate: new Date(data.lossDate).toISOString().split('.')[0],riskId:riskId,
                    lossReason: {name: data.lossReason.label,id: data.lossReason.value}},localEditData?.id).then((res) => {
                        if(res.status >= 200 && res.status <= 299) {
                            setLocalEditData({...localEditData,lossReason: data.lossReason,netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0]});
                            setLossData(prev => prev.map(item =>
                                item.id === localEditData.id ? { ...item, lossReason: data.lossReason, netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0] } : item
                            ));
                            Toast.fire({
                                title: t('codebook.successfullyEditedCodeBook'),
                                icon: 'success',
                            });
                        }else {
                            Toast.fire({
                                title: t('codebook.updateError'),
                                icon: 'error',
                            });
                        }
                })
            }else {
                setLocalEditData({...localEditData,lossReason: data.lossReason,netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0]});
                setLossData(prev => prev.map(item =>
                    item.id === localEditData.id ? { ...item, lossReason: data.lossReason, netLoss: data.netLoss,lossDate:new Date(data.lossDate).toISOString().split('.')[0] } : item
                ));
                Toast.fire({
                    title: t('codebook.successfullyEditedCodeBook'),
                    icon: 'success',
                });
            }
        }else {
            if(riskId) {
              addCodebook({...data,lossDate: new Date(data.lossDate).toISOString().split('.')[0],riskId:riskId,
                  lossReason: {lossReason: data.lossReason.label,id: data.lossReason.value}})
                  .then((res) => {
                  if(res.status === 200) {
                      const lossDate = new Date(data.lossDate);
                      lossDate.setHours(12, 0, 0, 0)
                      setLossData((prev) => [
                          ...prev,
                          {
                              id: res.data.id,
                              lossReason: data.lossReason,
                              netLoss: data.netLoss,
                              lossDate: lossDate.toISOString().split('.')[0],
                          }
                      ]);
                      Toast.fire({
                          title: t('codebook.successfullyAddedCodeBook'),
                          icon: 'success',
                      });
                  }else {
                      Toast.fire({
                          title: t('codebook.addError'),
                          icon: 'error',
                      });
                  }
              })
            }else {
                const lossDate = new Date(data.lossDate);
                lossDate.setHours(12, 0, 0, 0)
                setLossData((prev) => [...prev,{lossReason: data.lossReason,netLoss: data.netLoss,id: nanoid(),
                    lossDate: lossDate.toISOString().split('.')[0]}]);
                Toast.fire({
                    title: t('codebook.successfullyAddedCodeBook'),
                    icon: 'success',
                });
            }
        }
        isOpen(false)
        setTimeout(() => {
            setLoading(false)
        },500)
    };


    return (
        <>
            <Modal isOpen={open} className={`modal-sm verify-modal ${isCalendarOpen && 'calendarOpened'}`}>
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(submitForm)}>
                        <div className="close-img">
                            <img
                                src="/images/exclusion.svg"
                                alt="Exclusion"
                                onClick={(e) => toggleShowModal(e)}
                                style={{cursor: 'pointer'}}
                            />
                        </div>
                        <div className="modal-header history-header">
                            {isEdit ? t('codebook.codebookEdit') : t('codebook.codebookAdd')}
                        </div>
                        <label className="label-incurred mt-2">
                            {t('codebook.addCodebook')}
                        </label>
                        <SelectInfinite
                            api="/loss-reasons"
                            name="lossReason"
                            placeholder={t('codebook.codebookPlaceholder')}
                            // labelKey={'title'}
                            labelKey={getLanguage() === 'mne' ? 'name' : 'nameEn'}
                            className="loss-modal-select"
                            isClearable
                            // queryKeys={'title.contains'}
                            defaultValue={isEdit && localEditData?.lossReason}
                        />
                        <label className="label-incurred mt-2">
                            {t('codebook.loss')}
                        </label>
                        <InputText
                            type="text"
                            name="netLoss"
                            className="form-control input-field"
                            placeholder={t('codebook.lossPlaceholder')}
                            // disabled={disabled}
                            id="title"
                            defaultValue={isEdit ? localEditData?.netLoss : ''}
                        />
                        <label className="label-incurred mt-2">
                            {t('codebook.lossDate')}
                        </label>
                        <InputDate
                            name="lossDate"
                            defaultValue={isEdit && new Date(localEditData?.lossDate)}
                            // defaultValue={new Date('2025-02-12')}
                            placeholder={t('codebook.lossDatePlaceholder')}
                            style={{height: '65px!important'}}
                            forceSelected={true}
                            onCalendarOpen={() => setIsCalendarOpen(true)}
                            onCalendarClose={() => setIsCalendarOpen(false)}
                            // disabled={false}
                            isClearable={true}
                        />
                        <div className="modal-footer history-footer">
                            <button type={'button'} disabled={loading} className="secondary-btn" onClick={() => isOpen(false)}>
                                {t('codebook.revert')}
                            </button>
                            <button type={'button'} disabled={loading}  className="primary-btn"
                                    onClick={handleSubmit(submitForm)}>
                                {isEdit ? t('codebook.edit') : t('codebook.add')}
                            </button>
                        </div>
                    </form>
                </FormProvider>
            </Modal>
        </>
    );
}

export default LossModal;
